import { Injectable } from '@angular/core';
import { UnauthorizedErrorHandler } from 'ats-ui-lib';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class AtsUnauthorizedErrorHandler extends UnauthorizedErrorHandler {
  urlsToConsider = [
    environment.recruitmentApiEndpoint,
    environment.applicantApiEndpoint,
    environment.parserApiEndpoint,
  ];

  constructor(private authService: AuthService) {
    super();
  }

  async handleError(error: HttpErrorResponse): Promise<void> {
    const shouldGoToLogin = this.urlsToConsider.some(
      (url) => error.url != null && error.url.includes(url),
    );
    if (shouldGoToLogin) {
      await this.authService.logOut();
    }
  }
}
